export default __webpack_public_path__ + "static/media/image_7.5c5c6975.jpg";